/**
 * ChoiceQuestionUI - 選択肢形式コンポーネント (モック_GB組織_回答画面_v1.html s6 準拠)
 * Part5用 (O-11: 4択 / O-12: 3択): 縦並びの選択肢ボタン (.gb74-sel-grid)、
 * タップで回答記録＋自動進行
 */
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface ChoiceItem {
  id: string;
  text: string;
}

interface ChoiceQuestionUIProps {
  questionText: string;
  choices: ChoiceItem[];
  selectedChoiceId?: string;
  onAnswer: (choiceId: string) => void;
  onBack: () => void;
  canGoBack: boolean;
}

export const ChoiceQuestionUI: React.FC<ChoiceQuestionUIProps> = ({
  questionText,
  choices,
  selectedChoiceId,
  onAnswer,
  onBack,
  canGoBack,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <h2 className="gb74-q-text">{questionText}</h2>
      <div className="gb74-sel-grid">
        {choices.map((choice) => (
          <button
            key={choice.id}
            type="button"
            className={`gb74-sel-btn${selectedChoiceId === choice.id ? ' sel' : ''}`}
            onClick={() => onAnswer(choice.id)}
          >
            {choice.text}
          </button>
        ))}
      </div>
      {canGoBack && (
        <p className="gb74-back">
          <button type="button" onClick={onBack}>
            {t('questionnaire.previousQuestion')}
          </button>
        </p>
      )}
    </>
  );
};
